import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router";

function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div className="signup-container">
      <div className="signup-box" style={{ maxWidth: "900px", width: "100%" }}>
        <section>
          <div className="privacy-main-div">
            {/* Header Section */}
            <div className="privacy-heading-div">
              <h1>Privacy Policy</h1>
              <p>
                At <strong>Final Round</strong>, we value your privacy and are
                committed to protecting your personal data. This policy outlines
                how we collect, use, and safeguard your information when you use
                our platform or participate in our services.
              </p>
            </div>

            {/* Introduction */}
            <div className="privacy-section">
              <h2>1. Overview</h2>
              <p>
                This Privacy Policy describes our practices regarding data
                collection, usage, and storage. By using our platform, you agree
                to the collection and use of information as described below.
              </p>
            </div>

            {/* Information Collection */}
            <div className="privacy-section">
              <h2>2. What Information We Collect</h2>
              <p>We may collect the following types of information:</p>
              <ul>
                <li>
                  <strong>Personal Information:</strong> such as your name,
                  email address, contact details, and account credentials.
                </li>
                <li>
                  <strong>Technical Data:</strong> like your IP address, browser
                  type, device details, and usage statistics.
                </li>
                <li>
                  <strong>Payment Data:</strong> processed securely through
                  trusted third-party payment gateways.
                </li>
              </ul>
            </div>

            {/* Usage of Data */}
            <div className="privacy-section">
              <h2>3. How We Use Your Information</h2>
              <p>
                Your information is used to improve your experience and ensure
                the safety of our platform. We use it to:
              </p>
              <ul>
                <li>Verify your identity and manage your account.</li>
                <li>Facilitate transactions and provide customer support.</li>
                <li>Enhance our services and personalize your experience.</li>
                <li>
                  Send you notifications, updates, or promotional content
                  (optional).
                </li>
              </ul>
            </div>

            {/* Data Protection */}
            <div className="privacy-section">
              <h2>4. How We Protect Your Data</h2>
              <p>
                We implement strong administrative, technical, and physical
                safeguards to protect your personal information from
                unauthorized access, misuse, or loss.
              </p>
              <ul>
                <li>All sensitive data is encrypted and stored securely.</li>
                <li>
                  We use verified third-party services for secure payments.
                </li>
                <li>
                  Access to your personal information is strictly limited.
                </li>
              </ul>
            </div>

            {/* Cookies */}
            <div className="privacy-section">
              <h2>5. Cookies and Tracking</h2>
              <p>
                We use cookies to improve website functionality and analyze user
                behavior. Cookies help us remember your preferences and optimize
                content for a better experience.
              </p>
              <p>
                You can manage or disable cookies through your browser settings,
                though some features may not function correctly.
              </p>
            </div>

            {/* Third Parties */}
            <div className="privacy-section">
              <h2>6. Sharing Information with Third Parties</h2>
              <p>
                We do not sell or trade your personal information. However, we
                may share it with trusted partners who assist us in operating
                our services, provided they comply with strict confidentiality
                agreements.
              </p>
            </div>

            {/* Your Rights */}
            <div className="privacy-section">
              <h2>7. Your Rights</h2>
              <ul>
                <li>Access and review the personal data we hold about you.</li>
                <li>Request correction or deletion of your data.</li>
                <li>
                  Withdraw consent for marketing communications at any time.
                </li>
              </ul>
            </div>

            {/* Retention */}
            <div className="privacy-section">
              <h2>8. Data Retention</h2>
              <p>
                We retain your personal data for as long as necessary to fulfill
                the purposes for which it was collected or as required by law.
                When data is no longer needed, it is securely deleted.
              </p>
            </div>

            {/* Changes */}
            <div className="privacy-section">
              <h2>9. Updates to This Policy</h2>
              <p>
                We may update this Privacy Policy periodically to reflect
                changes in our practices. All updates will be posted here with
                the revision date.
              </p>
            </div>

            {/* Contact */}
            <div className="privacy-section">
              <h2>10. Contact Us</h2>
              <p>
                If you have any questions or concerns regarding this Privacy
                Policy or your data, please contact our support team at{" "}
                <a href="mailto:support@finalround.com">
                  support@finalround.com
                </a>
                .
              </p>
            </div>
            <Button onClick={() => navigate(-1)}>Back to page</Button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
